import * as React from "react";
import { Link, Card } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { useLink } from "@grandvisionhq/frk-routing";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import CategoryGroup from "../../../../../../CategoryGroup/CategoryGroup/CategoryGroup.js";
import { useRecentOrders } from "../../../../../hooks/Profile/hooks/use-recent-orders.js";
import { LoadingData } from "../../../../Profile/components/LoadingData.js";
/* empty css                  */
import { logOrderEvent } from "../../../../../../data-layer/data-layer/orders.js";
import { makeOrderDetailsClickEvent } from "../../../../../../data-layer/data-layer/utils.js";
const RecentOrders = ({ shouldShowOrderDate = true }) => {
  const { data, hasRecentOrders, loading, error } = useRecentOrders();
  const { getLabel, getFormattedLabel } = useIntl();
  const { href: ordersRoute, onClick } = useLink({ route: "me.orders" }) ?? {};
  const onViewRecentOrdersClick = (e) => {
    logOrderEvent({
      event_type: "my_account",
      event: "my_online_orders_click",
      order: {
        button: "View all orders"
      }
    });
    onClick?.(e);
  };
  if (loading) {
    return /* @__PURE__ */ React.createElement(LoadingData, null);
  }
  return /* @__PURE__ */ React.createElement("div", { className: "recent-orders__container" }, /* @__PURE__ */ React.createElement(Text, null, hasRecentOrders || error ? getLabel("account.profile.recentOrders.description") : getFormattedLabel("account.profile.recentOrders.noOrders")), hasRecentOrders ? /* @__PURE__ */ React.createElement("div", { className: "recent-orders__list" }, data?.map(({ orderNumber, orderDate, orderImageUrl, orderImageAlt, paymentStatus }) => /* @__PURE__ */ React.createElement(
    RecentOrder,
    {
      key: orderNumber,
      orderNumber,
      orderDate,
      orderImageUrl,
      orderImageAlt,
      paymentStatus,
      shouldShowOrderDate
    }
  ))) : /* @__PURE__ */ React.createElement(CategoryGroup, null), error && /* @__PURE__ */ React.createElement(Alert, { variant: "error", notifyScreenReader: false, className: "alert-m-default" }, getFormattedLabel("account.profile.recentOrders.error", {
    parseLink: true,
    parseHTML: true
  })), hasRecentOrders || error ? /* @__PURE__ */ React.createElement(Link, { href: ordersRoute, onClick: onViewRecentOrdersClick, iconAfter: "chevron-right" }, getLabel("account.profile.recentOrders.link")) : null);
};
const RecentOrder = ({
  orderNumber,
  orderDate,
  orderImageUrl,
  orderImageAlt,
  paymentStatus,
  shouldShowOrderDate
}) => {
  const { href: ordersDetailRoute, onClick } = useLink({ route: "me.orders.detail", params: { orderId: orderNumber } }) ?? {};
  const { dateTime, getFormattedLabel } = useIntl();
  const cardAriaLabel = getFormattedLabel("account.profile.recentOrders.orderLink", {
    labelData: {
      orderNumber
    }
  });
  const handleOnClick = (e) => {
    logOrderEvent(makeOrderDetailsClickEvent("my_account", orderNumber, paymentStatus));
    onClick?.(e);
  };
  return /* @__PURE__ */ React.createElement(
    Card,
    {
      key: orderNumber,
      href: ordersDetailRoute,
      onClick: handleOnClick,
      "aria-label": cardAriaLabel,
      className: "recent-orders__card-link"
    },
    /* @__PURE__ */ React.createElement(
      Card.Image,
      {
        alt: orderImageAlt,
        src: orderImageUrl,
        backgroundColor: "var(--color--shade-lightest)",
        className: "recent-orders__card-image"
      }
    ),
    /* @__PURE__ */ React.createElement("div", { className: "recent-orders__card-content-wrapper" }, /* @__PURE__ */ React.createElement(Card.Content, null, shouldShowOrderDate && /* @__PURE__ */ React.createElement(Card.Text, { className: "recent-orders__card-order-date" }, dateTime.formatShortDate(new Date(orderDate))), /* @__PURE__ */ React.createElement(Card.Heading, { variant: "subheading1" }, getFormattedLabel("account.profile.recentOrders.orderTitle", {
      labelData: {
        orderNumber
      }
    }))), /* @__PURE__ */ React.createElement(Card.Icon, { name: "chevron-right", className: "recent-orders__card-content-chevron" }))
  );
};
export {
  RecentOrders as default
};
//# sourceMappingURL=RecentOrders.js.map
